import { SquareOnlineStoreRestaurantBrief } from '__generated__/SquareOnlineStoreRestaurantBrief';
import { SquareOnlineStoreRestaurantBriefFields } from '__generated__/SquareOnlineStoreRestaurantBriefFields';
import Attachments from 'projects/components/Attachments';
import ContentSetting from 'projects/components/ContentSetting';
import { formatAndLinkify } from 'projects/components/FormatAndLinkify';
import SummaryCard from 'projects/components/summary/SummaryCard';
import SummaryCardItem from 'projects/components/summary/SummaryCardItem';
import { trackEditBriefEvent, trackViewedBriefEvent } from 'projects/events';
import { routes } from 'projects/routes';
import React, { useEffect } from 'react';

export interface Props {
    brief: SquareOnlineStoreRestaurantBrief;
}

function SummaryPage({ brief }: Props) {
    const fields = brief.fields as SquareOnlineStoreRestaurantBriefFields;

    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'Summary',
        });
    }, []);

    function handleEditClick(page: 'Details') {
        trackEditBriefEvent({
            id: brief.id,
            page: page,
        });
    }

    return (
        <ContentSetting>
            <SummaryCard
                heading={__('Tell us about your project')}
                onEditClick={() => handleEditClick('Details')}
                url={routes.brief(brief, 1)}
            >
                <SummaryCardItem title={__('Restaurant name')}>{fields.title}</SummaryCardItem>

                <SummaryCardItem title={__('Describe your restaurant')}>
                    {formatAndLinkify(fields.description)}
                </SummaryCardItem>

                {fields.referenceFiles.length > 0 && (
                    <SummaryCardItem title={__('Add any additional reference files')}>
                        {Attachments(fields.referenceFiles)}
                    </SummaryCardItem>
                )}

                {fields.existingWebsite !== '' && (
                    <SummaryCardItem
                        title={__('Link to your existing website or social sites if you have any')}
                    >
                        {formatAndLinkify(fields.existingWebsite)}
                    </SummaryCardItem>
                )}

                {fields.other != '' && (
                    <SummaryCardItem
                        title={__("Anything else you'd like to share with your designer?")}
                    >
                        {formatAndLinkify(fields.other)}
                    </SummaryCardItem>
                )}
            </SummaryCard>
        </ContentSetting>
    );
}

export default SummaryPage;
